import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer } from "rxjs";
import { ApiService } from "../services/api-service";
import { ApiServiceDelegate } from "../services/api-service-delegate";
import { ApiCollection } from "../services/api-collection";
import { AppCommon } from "../app-common";
import { StandardResponseModel, StatusResponseModel } from "../models/basic.model";
import { UserResponseModel } from "../models/user.model";
import { NzMessageService } from "ng-zorro-antd/message";
import { FeedbackComponent } from "src/app/pages/feedback/feedback.component";
import { FeedbackFilterModel, FeedbackIndResponseModel, FeedbackModel, FeedbackPointsModal, FeedbackResponseModel } from "../models/feedback.model";
import { FeedbackDrawerComponent } from "src/app/pages/feedback/feedback-drawer/feedback-drawer.component";
import { HttpHeaders } from "@angular/common/http";
import { FeedbackDetailsComponent } from "src/app/pages/feedback/feedback-details/feedback-details.component";
import { FeedbackEditComponent } from "src/app/pages/feedback/feedback-edit/feedback-edit.component";
import { MasterStatsModel } from "../models/dashboard.model";
import { TasksDrawerComponent } from "src/app/shared-components/tasks-drawer/tasks-drawer.component";
import { FeedbackListComponent } from "src/app/shared-components/feedback-list/feedback-list.component";
import { TopFeedbackUsersComponent } from "src/app/shared-components/top-feedback-users/top-feedback-users.component";

@Injectable({
    providedIn: "root",
})

export class FeedbackViewModel {

    parentComponent: FeedbackComponent;
    feedbackComponent: TopFeedbackUsersComponent;
    parentFeedbackListComponent: FeedbackListComponent;
    parentComponentDetails: FeedbackDetailsComponent;
    parentFeedbackDrawer: FeedbackDrawerComponent;
    parentFeedbackEdit: FeedbackEditComponent;
    TaskComponentDrawer:TasksDrawerComponent
    dashboardStatsResponseModel = new BehaviorSubject<MasterStatsModel>(new MasterStatsModel());
    applications = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    statuses = new BehaviorSubject<StatusResponseModel>(new StatusResponseModel());
    points = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel);
    feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(new FeedbackResponseModel());
    userResponseModel = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
    feedbackTypeResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel);
    feedbackUserPointsModel = new BehaviorSubject<FeedbackPointsModal>(new FeedbackPointsModal());
    feedbackModel = new BehaviorSubject<FeedbackIndResponseModel> (new FeedbackIndResponseModel())
    usersResponseModel = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
    constructor(
        private apiService: ApiService,
        private message: NzMessageService
        // private notification :NotificationService
    ) {

    }

    subscribeToFeedDetails(
        observerApplications: Observer<StandardResponseModel>,
        observerUserResponseModel: Observer<UserResponseModel>,
        observerfeedbackTypeResponseModel:Observer <StandardResponseModel>,
        observerFeedbackDetailResponseModel: Observer<FeedbackIndResponseModel>,
        observerStatuses: Observer<StandardResponseModel>,
        observerPoints: Observer<StandardResponseModel>,
       
      ){  this.applications.subscribe(observerApplications);
        this.userResponseModel.subscribe(observerUserResponseModel)
        this.feedbackTypeResponseModel.subscribe(observerfeedbackTypeResponseModel)
        this.feedbackModel.subscribe(observerFeedbackDetailResponseModel);
        this.statuses.subscribe(observerStatuses);
        this.points.subscribe(observerPoints);
        
    }

    


    subscribeToFeedbacks(
      observerApplications: Observer<StandardResponseModel>,
      observerUserResponseModel: Observer<UserResponseModel>,
      observerfeedbackTypeResponseModel: Observer<StandardResponseModel>
    ){
      this.applications.subscribe(observerApplications);
      this.userResponseModel.subscribe(observerUserResponseModel)
      this.feedbackTypeResponseModel.subscribe(observerfeedbackTypeResponseModel);
    }
    subscribeToFeedbackUserPoints(
      observerfeedbackUserPoints: Observer<FeedbackPointsModal>,
    ){
      this.feedbackUserPointsModel.subscribe(observerfeedbackUserPoints);
    }

    subscribeToFeedbacksList(
        observerApplications: Observer<StandardResponseModel>,
        observerStatuses: Observer<StatusResponseModel>,
        observerFeedbackResponseModel: Observer<FeedbackResponseModel>,
        observerUserResponseModel: Observer<UserResponseModel>,
        observerfeedbackTypeResponseModel: Observer<StandardResponseModel>
      ){
        this.applications.subscribe(observerApplications);
        this.statuses.subscribe(observerStatuses);
        this.feedbackResponseModel.subscribe(observerFeedbackResponseModel);
        this.userResponseModel.subscribe(observerUserResponseModel)
        this.feedbackTypeResponseModel.subscribe(observerfeedbackTypeResponseModel)
      }

    getFeedbackPoint(){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.FEED_POINT+ '?page='+1 + '&page_size=100',
            Success: (e: any) => {
                this.points.next(e)
                this.parentComponentDetails.pointsReceived();
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading statues", {nzDuration: 1000})
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getStatuses(caller){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK_STATUS+ '?page='+1 + '&page_size=100',
            Success: (e: any) => {
                this.statuses.next(e)
                if(caller == 'feedback-list'){
                    this.parentFeedbackListComponent.statusesReceived();
                }
                if(caller == 'feedback-detail'){
                    this.parentComponentDetails.statusesReceived();
                }
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading statues", {nzDuration: 1000})
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getFeedbackType(caller){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.FEED_TYPE+ '?page='+1 + '&page_size=100',
            Success: (e: any) => {
                this.feedbackTypeResponseModel.next(e);
                if(caller == 'feedback'){
                    this.parentComponent.feedBackTypeReceived();
                }
                if(caller == 'feedback-list'){
                    this.parentFeedbackListComponent.feedBackTypeReceived();
                }
                if(caller == 'feedback-detail'){
                    this.parentComponentDetails.feedBackTypeReceived();
                }
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }
    getUsers(caller){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.USER + "?page=1&page_size=1000" ,
            Success: (e: any) => {
                this.userResponseModel.next(e);
                if(caller == 'feedback'){
                    this.parentComponent.usersReceived();
                }
                if(caller == 'feedback-list'){
                    this.parentFeedbackListComponent.usersReceived();
                }
                if(caller == 'feedback-detail'){
                    this.parentComponentDetails.usersReceived();
                }
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getPayload(filters: FeedbackFilterModel){
        var str = '';
        if(filters.status_order){
            str += "&status_order=" +  filters.status_order;
        }
        if(filters.type_order){
            str += "&type_order=" + filters.type_order;
        }
        if(filters.title_order){
            str += "&title_order=" + filters.title_order;
        }
        if(filters.assigned_to_order){
            str += "&assigned_to_order=" + filters.assigned_to_order;
        }
        if(filters.date_order){
            str += "&date_order=" + filters.date_order
        }
        if(filters.descend){
            str += "&desc=" + filters.descend
        }
        if(filters.ascend){
            str += "&asc=" + filters.ascend
        }
        if(filters.app_name){
            str += "&app_name=" + filters.app_name
        }
        if(filters.submitted_by){
            str += "&submitted_by=" + filters.submitted_by
        }
        if(filters.assigned_to){
            str += "&assigned_to=" + filters.assigned_to
        }   
        if(filters.type){
            str += "&type=" + filters.type
        } 
        if(filters.title){
            str += "&title=" + filters.title
        } 
        if(filters.f_task){
            str += "&f_task=" + filters.f_task
        }
        if(filters.status){
            str += "&status=" + filters.status
        }
        return str
    }

    getFeedbacks(pageNo , filters, caller){
      var str = '';
      if(caller == 'feedback-list'){
        str ='?page='+pageNo + '&page_size=30'
    }
      
      str += this.getPayload(filters);
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.FEEDBACK + str,
            Success: (e: any) => {
                this.feedbackResponseModel.next(e); 
                this.parentFeedbackListComponent.feedbackReceived(); 
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getFeedbackStatuses(caller){
          let d: ApiServiceDelegate = {
              Data: {},
              Method:     "GET" ,
              Action: ApiCollection.FEEDBACK_STATUS+ '?page='+1 + '&page_size=100',
              Success: (e: any) => {
                if(caller == 'feedback-detail'){
                    this.parentComponentDetails.feedbackStatusRecieved(e);
                }
                if(caller == 'feedback'){
                    this.parentComponent.feedbackStatusRecieved(e);
                }
                if(caller == 'feedback-list'){
                    this.parentFeedbackListComponent.feedbackStatusRecieved(e);
                }
                     return e;
              },
              Error: (e: String) => {
                  this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                  return e;
              },
          };
          this.apiService.callService(d);
      }

    getFeedbackInd(id,caller){
      var str = '/' + id;
        let d: ApiServiceDelegate = {
            Data: {},
            Method:     "GET" ,
            Action: ApiCollection.FEEDBACK + str,
            Success: (e: any) => {
                this.feedbackModel.next(e);
                if(caller == 'FeedbackEdit'){
                    this.parentFeedbackEdit.feedbackReceived(e) ;
                } else if(caller == 'FeedbackDetails'){
                    this.parentComponentDetails.feedbackReceived(e);
                }
                  
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteFeedbackInd(id,){
        var str = '/' + id;
          let d: ApiServiceDelegate = {
              Data: {},
              Method:     "DELETE" ,
              Action: ApiCollection.FEEDBACK + str,
              Success: (e: any) => {
                this.parentComponentDetails.feedbackDeleteConfirm()
                return e;
              },
              Error: (e: String) => {
                  this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                  return e;
              },
          };
          this.apiService.callService(d);
      }

    editFeedback(date ){
        var str = '/' + date.id;
          let d: ApiServiceDelegate = {
              Data:date,
              Method:"PATCH" ,
              Action: ApiCollection.FEEDBACK + str,
              Success: (e: any) => {
                  this.feedbackModel.next(e);
                  this.parentFeedbackEdit.feedbackUpdatedDone(e);
                  return e;
              },
              Error: (e: String) => {
                  this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                  return e;
              },
          };
          this.apiService.callService(d);
      }
    
      getTopFeedbackUser(){
        let d: ApiServiceDelegate = {
            Data: {},
            Method:"GET",
            Action: ApiCollection.USERPOINTS+ '?page='+1 + '&page_size=1000',
            Success: (e: any) => {
            this.feedbackUserPointsModel.next(e) 
            this.feedbackComponent.feedbacklistReceived(e)
               
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading applications", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getApplications(caller){
        let d: ApiServiceDelegate = {
            Data: {},
            Method:"GET",
            Action: ApiCollection.APPLICATIONS + '?page='+1 + '&page_size=100',
            Success: (e: any) => {
                this.applications.next(e)
                if(caller == 'feedback'){
                    this.parentComponent.applicationReceived();
                }
                if(caller == 'feedback-list'){
                    this.parentFeedbackListComponent.applicationReceived();
                }
                if(caller == 'feedback-detail'){
                    this.parentComponentDetails.applicationReceived();
                }
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading applications", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    createFeedback(feedbackModel: FeedbackModel,){
        let d: ApiServiceDelegate = {
            Data: feedbackModel,
            Method: "POST" ,
            Action: ApiCollection.FEEDBACK ,
            Success: (e: any) => {
                this.parentFeedbackDrawer.feedbackUpdated();
                this.message.success("Feedback Created", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while creating feedback", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    removeMedia(media_id, caller){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.MEDIA + '/' + media_id,
            Success: (e: any) => {
                if(caller === 'feedback-drawer'){
                    this.parentFeedbackDrawer.attachmentRemoved(media_id);
                }
                if(caller === 'feedback-edit'){
                    this.parentFeedbackEdit.attachmentRemoved(media_id);
                }

                this.message.success("Media removed", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while removing media", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    downloadMedia(url, name, caller){
        var completeUrl = url;
        let httpHeaders = new HttpHeaders();
        httpHeaders.append("Accept", "application/json");
        this.apiService.downloadFile(completeUrl, httpHeaders).subscribe((e: any) => {

            if(caller === 'feedback-drawer'){
                this.parentFeedbackDrawer.fileDownloaded(e.res.body, name);
            }
            if(caller === 'feedback-edit'){
                this.parentFeedbackEdit.fileDownloaded(e.res.body, name);
            }



        },
        (error: any) => {
            this.message.error('Error while downloading');
            return error;
          }

        );
    }

    uploadMedia(file, currentUser, fileName, caller){
        var formData = new FormData();
        var httpHeaders = new HttpHeaders();
        var uploadContentType = { type: 'multipart/form-data' }
        formData.set('file', new Blob([file], uploadContentType), file.name);
        formData.set('created_by', currentUser);
        formData.set('name', fileName);
        httpHeaders.append('Accept', 'application/x-www-form-urlencoded');
        this.apiService.uploadFile(String(ApiCollection.MEDIA), formData,  httpHeaders).subscribe((e: any) => {

            if(caller === 'feedback-drawer'){
                this.parentFeedbackDrawer.fileUploaded(e.res);
            }
            if(caller === 'feedback-edit'){
                this.parentFeedbackEdit.fileUploaded(e.res);
            }



            this.message.success('File uploaded');
          },
          (error: any) => {
            
            if(caller === 'feedback-drawer'){
                this.parentFeedbackDrawer.fileUploadedError();
            }
            if(caller === 'feedback-edit'){
                this.parentFeedbackEdit.fileUploadedError();
            }


            this.message.error(error);
          }
          );




    }



}
